module.exports = __webpack_public_path__ + "static/media/weg.a1760bbe.svg";